import { GQLProductTileFragment } from '@theprintbar/graphql';
import { getFlatLaysSortedBySide, getSortedColours } from '..';
import { ImageSize, WebRoutes } from '../..';
import { ProductImageParams } from '../../routes/web/api';

export function getProductImageUrl({
	product,
	...params
}: ProductImageParams & {
	product?: GQLProductTileFragment;
}) {
	if (!!product && !params.design) {
		if (params.colourCode || params.side) {
			const colours = getSortedColours(product.colours);

			const colour = params.colourCode ? colours.find(c => c.colour.code === params.colourCode) : colours[0] || colours[0];

			const sides = getFlatLaysSortedBySide(colour?.flatImages || []);
			const flatlay = params.side ? sides.find(s => s.side?.side === params.side) : sides[0] || sides[0];

			if (flatlay?.image) {
				return `${flatlay.image.url}?size=${params.size ?? ImageSize.Large}`;
			}
		} else {
			const mainImage = product.mainImage?.[0]?.image?.url;
			if (mainImage) {
				return `${mainImage}?size=${params.size ?? ImageSize.Large}`;
			}
		}
	}

	return WebRoutes.API.images.productImage(params);
}
